import {ModuleEnum} from 'src/api/ProactApiClient';
import {PersonnelCustomOperations} from './customOperations';
import {useModulePermissions} from './useModulePermissions';

/**
 * Hook for Personnel module permissions.
 * Includes standard operations plus Personnel-specific custom operations.
 */
export function usePersonnelPermissions() {
  return useModulePermissions(ModuleEnum.Personnel, PersonnelCustomOperations);
}
